import React from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { TableBody, TableBodyItem } from "../../../../Table/Table";
import { IMessageData } from "./OldRecentChat";
import Flex from "../../../../DefaultStyles/Flex";
import { findUrl } from "../../../../../ApiWeb/ApiWebTS";

interface STableText {
  isSystem: boolean;
}

interface RecentChatMessageProps {
  d: IMessageData;
  chatId?: string;
  index: number;
  messageData: IMessageData[];
}

export default function RecentChatMessage({
  d,
  chatId,
  index,
  messageData,
}: RecentChatMessageProps) {
  return (
    <TableBody
      style={{
        backgroundColor:
          d?.sendBy === 0
            ? "#ffffff"
            : chatId?.split("@")[1] === String(d?.sendBy)
            ? "#f5f5f5"
            : "#fffae8",
      }}
      key={index}
    >
      <TableBodyItem>
        <TableText isSystem={d?.sendBy === 0}>
          {d?.sendBy === 0
            ? "알림"
            : chatId?.split("@")[1] === String(d?.sendBy)
            ? "파티장"
            : "파티원"}
        </TableText>
      </TableBodyItem>

      <TableBodyItem>
        <Flex>
          <TableText
            isSystem={d?.sendBy === 0}
            dangerouslySetInnerHTML={{
              __html: findUrl(d?.msg),
            }}
          />

          <>
            {messageData[0]?.key === d?.key && (
              <LatestMessageBadge isSystem={d?.sendBy === 0}>
                가장 최근 메세지
              </LatestMessageBadge>
            )}
          </>
        </Flex>
      </TableBodyItem>

      <TableBodyItem>
        <TableText isSystem={d?.sendBy === 0}>
          {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm:ss")}
        </TableText>
      </TableBodyItem>

      <TableBodyItem>
        <TableText isSystem={d?.sendBy === 0}>{d?.key}</TableText>
      </TableBodyItem>
    </TableBody>
  );
}

const TableText = styled.div<STableText>`
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
  color: ${({ isSystem, theme }) =>
    isSystem ? theme.color.gray400 : theme.color.textColor};

  a {
    all: unset;
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const LatestMessageBadge = styled.span<STableText>`
  margin-left: 8px;
  border-radius: 3px;
  background-color: ${({ isSystem, theme }) =>
    isSystem ? theme.color.gray400 : theme.color.white};
  padding: 4px 6px;

  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  text-align: center;
  color: ${({ isSystem, theme }) =>
    isSystem ? theme.color.white : theme.color.gray400};
`;
